import { ExternalLink, Globe, LogIn, UserPlus, KeyRound, DollarSign, Shield, Info } from 'lucide-react';
import { BACKEND_URL } from '../../config';

const BASE = BACKEND_URL.replace('/api', '').replace(/\/$/, '');

const PAGES = [
  { path: '/landing', label: 'Landing Page', desc: 'Main marketing page with hero, features, and CTA', icon: Globe },
  { path: '/login', label: 'Login', desc: 'Sign-in with email/password and one-click demo access', icon: LogIn },
  { path: '/register', label: 'Register', desc: 'New user registration with org creation', icon: UserPlus },
  { path: '/forgot-password', label: 'Forgot Password', desc: 'Password reset request via email', icon: KeyRound },
  { path: '/pricing', label: 'Pricing', desc: 'Subscription tiers with feature comparison', icon: DollarSign },
  { path: '/about', label: 'About Us', desc: 'Company story, mission, goal, and slideshow', icon: Info },
  { path: '/privacy', label: 'Privacy Policy', desc: 'Data handling and user privacy terms', icon: Shield },
];

export default function DevPublicPages() {
  const openPage = (path) => {
    window.open(`${BASE}${path}`, '_blank');
  };

  return (
    <div className="p-6 max-w-4xl mx-auto" data-testid="dev-public-pages">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-white">Public Pages</h1>
        <p className="text-sm text-slate-400 mt-1">{PAGES.length} publicly accessible pages — no authentication required</p>
      </div>

      <div className="grid gap-3">
        {PAGES.map((pg) => (
          <button
            key={pg.path}
            onClick={() => openPage(pg.path)}
            className="flex items-center gap-4 w-full text-left bg-slate-900 border border-slate-800 rounded-lg px-5 py-4 hover:border-emerald-500/40 hover:bg-slate-800/60 transition-all group"
            data-testid={`public-page-${pg.path.replace('/', '')}`}
          >
            <div className="w-10 h-10 rounded-lg bg-slate-800 group-hover:bg-emerald-500/10 flex items-center justify-center transition-colors">
              <pg.icon className="w-5 h-5 text-slate-400 group-hover:text-emerald-400 transition-colors" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-white">{pg.label}</p>
              <p className="text-xs text-slate-500 truncate">{pg.desc}</p>
            </div>
            <div className="flex items-center gap-3">
              <code className="text-xs text-slate-600 font-mono hidden sm:block">{pg.path}</code>
              <ExternalLink className="w-4 h-4 text-slate-600 group-hover:text-emerald-400 transition-colors" />
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
